import styled from 'react-emotion';

export const ModalDescription = styled('p')`
  margin: 0 0 24px 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  line-height: 1.5;
`;

export const PermissionsList = styled('div')`
  max-height: 400px;
  overflow-y: auto;
`;

export const PermissionModule = styled('div')`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
  letter-spacing: 0.5px;
`;

export const PermissionItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  &:last-child {
    border-bottom: none;
  }
`;

export const PermissionLabel = styled('span')`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
`;

export const ErrorMessage = styled('div')`
  padding: 16px;
  background-color: #ffebee;
  color: #c62828;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
`;
